import React from "react";
import './YourBrand.css';
const YourBrand = () => {
 // const isTablet = checkViewportSize();
  return (
    <>
      <section id="BrandedDigitalExperiences">
        <div className="yourBrandMain">
          <div className="container">
            <div className="row justify-content-center stickyHeadingBrand">
              <div className="col-lg-12">
                  <div className="headYourBrand ">
                  <h2>Your Brand, Our Tech</h2>
                  <p>
                    Branded digital experiences that increase awareness, build lasting
                    customer relationships and drive more commission-free rentals.
                  </p>
                  <small>On our platform, your storefront takes center stage for guests to:</small>
                  <ul>
                    <li>
                      <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                      <span>Visit Your Website</span>
                    </li>
                    <li>
                      <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                      <span>Call You Directly</span>
                    </li>
                    <li>
                      <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                      <span>Send Direct Messages</span>
                    </li>
                    <li>
                      <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                      <span>Email Your Business</span>
                    </li>
                    <li>
                      <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                      <span>Follow On Social Media</span>
                    </li>
                    <li>
                      <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                      <span>Search Your Business Online</span>
                    </li>
                  </ul>
                  </div>
              </div>
            </div>
            <div className="swiper backgound_gradient">
              <div className="swiper-wrapper" aria-live="polite">
                <div className="swiper-slide gradient_slide" aria-label="1 / 4">
                  <div sticky-image="0" className="rd_marron"></div>
                </div>
                <div className="swiper-slide gradient_slide" aria-label="2 / 4">
                  <div sticky-image="1" className="rd_forest"></div>
                </div>
                <div className="swiper-slide gradient_slide" aria-label="3 / 4">
                  <div sticky-image="2" className="rg_pink"></div>
                </div>
                <div className="swiper-slide gradient_slide" aria-label="4 / 4">
                  <div sticky-image="3" className="rg_red"></div>
                </div>
              </div>
            </div>

            <div className="yourBrandOuter">
              <div id="scroll-block" className="yourBrandLeft">
                <div scrolling-block="0" className="scrolling_item">
                  <div className="yourBrandInner">
                    <h3>Create a <span>free rental website.</span></h3>
                    <p>
                      Rentid supports your marketing with a <span>free vehicle rental website</span>
                      —use our simple website builder to enhance your reach, attract customers, and
                      build a standout brand at no extra cost. Enjoy easy setup and increased
                      visibility for your business.
                    </p>
                  </div>
                </div>

                <div scrolling-block="1" className="scrolling_item">
                  <div className="yourBrandInner">
                    <h3>Already <span>have your own</span> website?</h3>
                    <p>
                      We provide an <span>embed link</span> that seamlessly integrates with your
                      site, making it rental ready. This saves you time on setup, ensures your
                      branding stays consistent, and enhances your site with powerful rental
                      management tools.
                    </p>
                  </div>
                </div>

                <div scrolling-block="2" className="scrolling_item">
                  <div className="yourBrandInner">
                    <h3><span>Your brand</span> on any mobile device.</h3>
                    <p>
                      Your <span>website is fully responsive</span>, included at no extra cost to
                      save you time, money and headaches. Guests will appreciate the flexibility of
                      connecting with your brand seamlessly on tablets or mobile devices.
                    </p>
                  </div>
                </div>

                <div scrolling-block="3" className="scrolling_item">
                  <div className="yourBrandInner">
                    <h3><span>Your storefront</span> on an app experience.</h3>
                    <p>
                      Your dedicated app experience provides renters with an intuitive, user-friendly
                      platform to explore your business, check vehicle availability, and manage
                      bookings—enhancing both your rental operations and the guest experience.
                    </p>
                    <div className="yourBrandLeftBtn">
                      <a href="/">
                        <img className="img-fluid" src="/img/google_play.svg" alt="icon" />
                      </a>
                      <a href="/">
                        <img className="img-fluid" src="/img/app_store.svg" alt="icon" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="yourBrandRight">
                <div className="mobile_bg">
                  <div className="background_grain_black">
                    <div className="grains_image"></div>
                  </div>
                </div>
                <div className="swiper scrolling-images">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide scrolling_image_slide" role="group" aria-label="1 / 4">
                      <div className="changing_img">
                        <img className="contain_image" width="450" src="/img/rentdirect/your_brand_1.webp" alt="Your Brand 1" />
                      </div>
                    </div>
                    <div className="swiper-slide scrolling_image_slide" role="group" aria-label="2 / 4">
                      <div className="changing_img">
                        <img className="contain_image" width="520" src="/img/rentdirect/your_brand_2.webp" alt="Your Brand 2" />
                      </div>
                    </div>
                    <div className="swiper-slide scrolling_image_slide" role="group" aria-label="3 / 4">
                      <div className="changing_img">
                        <img className="contain_image" width="506" src="/img/rentdirect/your_brand_3.webp" alt="Your Brand 3" />
                      </div>
                    </div>
                    <div className="swiper-slide scrolling_image_slide scrolling_slide_video" role="group" aria-label="4 / 4">
                      <div className="changing_img">
                        <video width="226" height="423" controls loop autoPlay muted playsInline>
                          <source src="/img/rentdirect/your_brand_4.mov" type="video/mp4" />
                        </video>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>


        <div className="yourBrandMobileMain">
            <div className="container">
                <div className="row justify-content-center stickyHeadingBrand">
                    <div className="col-lg-12">
                          <div className="headYourBrand ">
                          <h2>Your Brand, Our Tech</h2>
                          <p>
                            Branded digital experiences that increase awareness, build lasting
                            customer relationships and drive more commission-free rentals.
                          </p>
                          <small>On our platform, your storefront takes center stage for guests to:</small>
                          <ul>
                            <li>
                              <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                              <span>Visit Your Website</span>
                            </li>
                            <li>
                              <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                              <span>Call You Directly</span>
                            </li>
                            <li>
                              <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                              <span>Send Direct Messages</span>
                            </li>
                            <li>
                              <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                              <span>Email Your Business</span>
                            </li>
                            <li>
                              <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                              <span>Follow On Social Media</span>
                            </li>
                            <li>
                              <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                              <span>Search Your Business Online</span>
                            </li>
                          </ul>
                          </div>
                    </div>
                </div>
        
                <div className="yourBrandMobileOuter">
                  <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                      <div className="yourBrandMobileLeft">
                        <h3>Create a <span>free rental website.</span></h3>
                        <p>
                          Rentid supports your marketing with a <span>free vehicle rental website</span>—use 
                          our simple website builder to enhance your reach, attract customers, and build a 
                          standout brand at no extra cost. Enjoy easy setup and increased visibility for 
                          your business.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="yourBrandMobileRight">
                        <img className="img-fluid" src="/img/rentdirect/your_brand_1.webp" alt="Your Brand 1"/>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="yourBrandMobileOuter">
                  <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                      <div className="yourBrandMobileLeft">
                        <h3>Already <span>have your own</span> website?</h3>
                        <p>
                          We provide an <span>embed link</span> that seamlessly integrates with your site, 
                          making it rental ready. This saves you time on setup, ensures your branding stays 
                          consistent, and enhances your site with powerful rental management tools.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="yourBrandMobileRight">
                        <img className="img-fluid" src="/img/rentdirect/your_brand_2.webp" alt="Your Brand 2"/>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="yourBrandMobileOuter">
                  <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                      <div className="yourBrandMobileLeft">
                        <h3><span>Your brand</span> on any mobile device.</h3>
                        <p>
                        Our <span>websites come fully responsive</span> and included at no extra cost. Guests can 
                        effortlessly connect with your brand on tablets or mobile devices, ensuring 
                        a user-friendly and professional experience.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="yourBrandMobileRight">
                        <img className="img-fluid" src="/img/rentdirect/your_brand_3.webp" alt="Your Brand 3"/>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="yourBrandMobileOuter">
                  <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                      <div className="yourBrandMobileLeft">
                        <h3><span>Your storefront</span> on an app experience.</h3>
                        <p>
                        Your dedicated app experience provides renters with an intuitive, user-friendly platform 
                        to explore your business, check vehicle availability, and manage bookings—enhancing both 
                        your rental operations and the guest experience.
                        </p>
                        <div className="yourBrandMobileLeftBtn">
                        <a href="/">
                          <img className="img-fluid" src="/img/google_play.svg" alt="icon" />
                        </a>
                        <a href="/">
                          <img className="img-fluid" src="/img/app_store.svg" alt="icon" />
                        </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="yourBrandMobileRight">
                          <video width="226" height="423" controls loop autoPlay muted playsInline>
                              <source src="/img/rentdirect/your_brand_4.mov" type="video/mp4" />
                          </video>
                      </div>
                    </div>
                  
                  </div>
                </div>
            </div>
        </div>
      </section>
    </>
  );
};

export default YourBrand;
